module.exports = __webpack_public_path__ + "img/w3_chevron_up_grey.b91bab03.png";